import React from "react";
export const replacement = [
  {
    reg: /\*/g,
    dest: "×",
  },
  {
    reg: /\//g,
    dest: "÷",
  },
];

export default class ResultPanel extends React.Component {
  constructor() {
    super();
    this.inputRef = React.createRef();
  }
  componentDidMount() {
    if (this.props.noOfCartonWrapper) {
      document.getElementById("cal_input").select()
    }
  }

  render() {
    const { last, cur } = this.props;
    let finalCur = cur,
      finalLast = last;
    replacement.forEach((item) => {
      finalCur = finalCur.replace(item.reg, item.dest);
      finalLast = finalLast.replace(item.reg, item.dest);
    });

    return (
      <div className="result-panel">
        {/* <div className="last-row result-display">{finalLast}</div> */}
        <input
          ref={this.inputRef}
          readOnly
          id="cal_input"
          className="cur-row input-value"
          value={finalCur}
        />
      </div>
    );
  }
}
